

import React from "react"
import { PostConfigData, QuizConfigData, QuizPosition, QuizProfile, QuizScoreRanking, QuizScores, QuizSurveyResults, QuizType } from "../Shared/Party/PartyConfigData";
import { Quiz } from "./Quiz";
import { ChartData } from "../Shared/ProfileData/ChartData";
import '../InteractiveMap/ColorFills.css'
import { ChartDisplay, ChartDisplayProps } from "../InteractiveMap/ChartDisplay";
import { GetClasses } from "../InteractiveMap/CSSPicker";
import { ActionSharePanel, ActionSharePanelProps } from "./ActionSharePanel";
import { StateManagerContext } from "./StateManagerContext";
import { UIConfigContext } from "./UIConfigContext";
import { UserAction } from "../Shared/UserData";
import { ActionButton, ActionButtonProps, ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";
import { FanboxStyling } from "./CSSUtilities";




export type QuizResultsPanelProps = {
    height: number;
    image: string;
    quizType: QuizType,
    quizConfig : QuizConfigData,
    quizId: string,
    quizEngine: Quiz,
    numberInParty : number,
    quizOpened : number,
    quizCloses : number,
    partyId : string,
}

export const QuizResultsPanel = ({ height, image, quizType, quizConfig, quizEngine, quizId, numberInParty, quizOpened, quizCloses, partyId }: QuizResultsPanelProps): React.JSX.Element => {
    const [loadedFromServer, setLoadedFromServer] = React.useState<boolean>(false);
    const [sharePage, setSharePage] = React.useState<boolean>(false);
    const rcRef = React.useRef<number>(0);
    const [rc,setRC] = React.useState(0);
    const timerRef= React.useRef<number>(-1);
    const surveyCounts = React.useRef<number[][]>([]);
    const previousVotes = React.useRef<number>(0);
    const serverError = React.useRef<boolean>(false);
    const loadingFromServer = React.useRef<boolean>(false);
    const surveyResults = React.useRef<QuizSurveyResults | null>(null);
    const rankings = React.useRef<QuizScoreRanking[]>([]);
    const profile = React.useRef<QuizProfile | null>(null);
    const position = React.useRef<QuizPosition | null>(null);
    const userAction = React.useRef<UserAction | null>(null);
    const stateManager = React.useContext(StateManagerContext);
    const uiConfig = React.useContext(UIConfigContext);

    /*const postConfig : PostConfigData = {
        itemId : stateManager.context().itemId + quizConfig.itemId,
        title : '',
        author : '@FANBOX',
        layout : 'single-element',
        rotate : 'none',
        messageDisplay : 'none',
        elements : [{
            itemId : stateManager.context().itemId + quizConfig.itemId + '0',
            layout : 'primary-left',
            primary : {
                buttonText : 'Play',
                buttonClick : 'opt:' + quizConfig.itemId,
                buttonColor : 'pink',
                buttonTextColor : 'black',
            },
            secondary : {

            }
        }]
    }*/


    const _image = image === undefined ? '/images/default-quiz-image.png' : image;
    if (!(loadedFromServer || loadingFromServer.current)) {
        loadingFromServer.current = true;
        const getRanking = async () => {
            try {
                const uri = '/api/quizresults';
                const data = { 
                    itemId: quizId, 
                    partyId: partyId, 
                    results: quizEngine.Results(),
                    userId : stateManager.user().fanbox.id,
                    accessToken : stateManager.user().fanbox.accessToken ?? '',
                    devmode : stateManager.devMode()
                };
                const response = await fetch(uri, {
                    method: "POST",
                    headers: { "content-type": "application/json" },
                    body: JSON.stringify(data)
                });
                const json = await response.json();
                if (json.error)
                    serverError.current = true;
                else if (quizType === 'quiz') {
                    
                        //scores.current = json.scores as QuizScores;
                        rankings.current = json.rankings as QuizScoreRanking[];
                        position.current = json.position as QuizPosition;
                        userAction.current = json.action as UserAction;

                        /*const beat = scores.current.uniquePlayers - ranking.current;
                        const totalPoints = quizEngine.TotalPoints();
                        const quizName = quizConfig.title + ' ' + quizConfig.subTitle;

                        scores.current.shareTitles = scores.current.shareTitles.map((title) => {
                            return title.replaceAll('{beat}', beat +'').replaceAll('{points}', totalPoints + '').replaceAll('{quiz}', quizName).replaceAll('{nickname}', stateManager.user().userInformation.nickname);
                        })

                        scores.current.shareTexts = scores.current.shareTexts.map((text) => {
                            return text.replaceAll('{beat}', beat +'').replaceAll('{points}', totalPoints + '').replaceAll('{quiz}', quizName).replaceAll('{nickname}', stateManager.user().userInformation.nickname);
                        })

                        postConfig.title = scores.current.shareTitles[0];
                        postConfig.elements[0].primary.text = scores.current.shareTexts[0];
                        const pes = postConfig.elements[0].secondary;
                        if(pes !== undefined)
                            pes.imageSrc = scores.current.shareImage[0];
                        */

                    
                }
                else if (quizType === 'survey') {
                    if (json.survey === undefined)
                        serverError.current = true;
                    else
                        surveyResults.current = json.survey as QuizSurveyResults;
                }
                else {
                    if (json.profile === undefined)
                        serverError.current = true;
                    else
                        profile.current = json.profile as QuizProfile;
                }
            }
            catch (e) {
                console.log(e);
                serverError.current = true;
            }
            setLoadedFromServer(true);

        }
        getRanking();
    }
    const imageBottom = Math.floor(height * 0.33);
    const txtPanelWidth = Math.floor(uiConfig.width * (400/ 500));
    const buttonWidth = Math.floor(uiConfig.width * 241 / 500);
    const logoTop = Math.floor(imageBottom - 390 + 343.35);
    const title = quizType === 'quiz' ? 'Your Results' : (quizType === 'survey' ? 'Your Answers' : 'Your Profile');

    var scoreElements = Array<JSX.Element>();

    if(position.current !== null) {
        const boardWidth = txtPanelWidth - 75;
   
        scoreElements.push(<div style={{fontSize: "18px", lineHeight: "28px", fontWeight: 400, textAlign: "center", color: "white", gridRow : 1, gridColumn : '1 / span 2'}}> You completed the quiz earning {quizEngine.Points()} points in just {Math.floor(quizEngine.Time()/1000)} seconds earning a Time Bonus of {quizEngine.TimeBonus()} to make a grand total {quizEngine.TotalPoints()} points</div>);
        rankings.current.forEach((ranking, index) => {
            scoreElements.push(<div key={"QuizResultPanel_" + quizId + "_rankingNumber" + index} style ={{
                minWidth : '75px',
                width : '75px',
                maxWidth : '75px',
                maxHeight : '30px',
                height : '30px',
                minHeight : '30px',
                border : '2px solid white',
                borderRadius : '8px',
                marginTop : '10px',
                gridRow : index + 2,
                gridColumn : 1,
                
            }}>
                <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 600, color : 'white', textAlign : "center", paddingTop : '6px'}}>{(index + 1) + ''}</span>
            </div>)
        
        scoreElements.push(<div key={"QuizResultPanel_" + quizId + "_rankingRow" + index} style ={{
            minWidth : boardWidth + 'px',
            width : boardWidth + 'px',
            maxWidth : boardWidth + 'px',
            maxHeight : '30px',
            height : '30px',
            minHeight : '30px',
            border : '2px solid white',
            borderRadius : '8px',
            marginTop : '10px',
            marginLeft : '10px',
            gridRow : index + 2,
            gridColumn : 2,
            display : 'grid',
            gridTemplateRows : 'auto',
            gridTemplateColumns : 'auto'
            
        }}>
            <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 600, color : 'white', textAlign : "left", marginTop : '0px', gridRow : 1, gridColumn : 1, marginLeft : '10px'}}>{ranking.nickname}</span>
            <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 900, color : 'white', textAlign : "right", marginTop : '0px', gridRow : 1, gridColumn : 2}}>{ranking.score}</span>
        </div>)
        });

        scoreElements.push(<div key={"QuizResultPanel_" + quizId + "_rankingNumber" + position.current} style ={{
            minWidth : '75px',
            width : '75px',
            maxWidth : '75px',
            maxHeight : '30px',
            height : '30px',
            minHeight : '30px',
            border : '2px solid white',
            borderRadius : '8px',
            marginTop : '10px',
            gridRow : rankings.current.length + 2,
            gridColumn : 1,
            
        }}>
            <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 900, color : 'red', textAlign : "center", paddingTop : '6px'}}>{position.current.absolutePosition + ''}</span>
        </div>);
        scoreElements.push(<div key={"QuizResultPanel_" + quizId + "_rankingRow" + position.current} style ={{
            minWidth : boardWidth + 'px',
            width : boardWidth + 'px',
            maxWidth : boardWidth + 'px',
            maxHeight : '30px',
            height : '30px',
            minHeight : '30px',
            border : '2px solid white',
            borderRadius : '8px',
            gridRow : rankings.current.length + 2,
            gridColumn : 2,
            marginTop : '10px',
            marginLeft : '10px',
            display : 'grid',
            gridTemplateRows : 'auto',
            gridTemplateColumns : 'auto'
            
        }}>
            <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 600, color : 'white', textAlign : "left", marginTop : '0px', gridRow : 1, gridColumn : 1, marginLeft : '10px'}}>You</span>
            <span style={{ fontFamily : 'roboto', fontSize : '18px', fontWeight : 900, color : 'white', textAlign : "right", marginTop : '0px', gridRow : 1, gridColumn : 2}}>{quizEngine.TotalPoints()}</span>
        </div>

        )

        const showShareActionHandler : ActionHandler = (_action) => { setSharePage(true); return true;}
        const showShareAction = CreateAction('showSharePage', [], showShareActionHandler);
        const buttonStyling: FanboxStyling = {
            width: buttonWidth,
            height: 66,
            boundary: {
              radius: 75,
              margin: {
                quadType: 'margin',
                top: 20,
                bottom: 0,
                left: (txtPanelWidth - buttonWidth) * 0.5,
                right: (txtPanelWidth - buttonWidth) * 0.5
              }
            },
            color: {
              background: 'orange',
              foreground: 'white'
            },
            font: {
              size: 24,
              weight: 'bold'
            },
            
          }
        const bprops : ActionButtonProps = {
            styling : buttonStyling,
            action : showShareAction,
            actionData : EmptyActionData,
            text : 'Share',
            prompt : 'center'


        }
        scoreElements.push(<ActionButton {...bprops}/>);
    }

    var surveyElements = Array<JSX.Element>();
    if(surveyResults.current !== null) {

        if(surveyCounts.current.length === 0) {
            for(let a = 0; a < surveyResults.current.questions.length; a++) {
                const array = Array<number>();
                for(let b = 0; b < surveyResults.current.questions[a].results.length; b++)
                {
                    array.push(0);
                }
                surveyCounts.current.push(array);
            }
        }

        var prop = (Date.now() - quizOpened)/(quizCloses - quizOpened);
        if(prop > 1)
        {
            if(timerRef.current >=0){
                window.clearInterval(timerRef.current);
                timerRef.current = -1;
            }
            prop = 1;
        }

        const totalVotes =  Math.floor(prop * numberInParty);
        const newVotes = totalVotes - previousVotes.current;
        previousVotes.current = totalVotes;
        surveyElements.push(<span style={{ fontFamily : 'roboto', fontSize : '28px', fontWeight : 500, color : 'white', marginTop : '25px'}}>{totalVotes} Fans Answered</span>);
        


        surveyResults.current.questions.forEach((questionResult, index) => {
            for(let a = 0; a < newVotes; a++) {
                var r = Math.random();
                var ui = 0;
                questionResult.results.forEach((result, ri)=> {
                    r-= result.votes;
                    if(r < 0){
                        ui = ri;
                        r = 1000;
                    }
                });
                surveyCounts.current[index][ui]++;
            }
        surveyElements.push(<span style={{ fontFamily : 'roboto', fontSize : '28px', fontWeight : 500, color : 'white', marginTop : '25px'}}>{questionResult.question}</span>);
        const chartData : ChartData = {
            title : questionResult.annotation,
            chartType : 'donut',
            data : questionResult.results.map((answer, ai) => { return {name : answer.name, value : surveyCounts.current[index][ai]}}) //Math.round(answer.votes * numberInParty)
        };

        if(timerRef.current === -1 && prop < 0.9) {
            timerRef.current = window.setInterval(()=>{
                rcRef.current++;
                setRC(rcRef.current);
            }, 1000)
        }

        const chartProps: ChartDisplayProps = {
            chartData: chartData,
            x: 0,
            y: 0,
            width: txtPanelWidth,
            height: 200,
            options: {
                showAxis: false,
                barCSS: GetClasses(questionResult.results.length,'hover'),
                barHighlightCSS: GetClasses(questionResult.results.length,'Highlight'),
                axisColor: 'black',
                bottomLabelSpace : 0,
                yCalculator : 'variation',
                yCalcParameter : 2,
                valuePostfix: '%',
                textHeight: 14,
                xmin: 0,
                xmax: 0,
                isDate: false,
                idPrefix: "QuizResultPanel_" + quizId +'_question_' + index,
                barWidth : 0.5,
            }
        }
        surveyElements.push(<svg width={txtPanelWidth} height={300} style={{marginTop : '15px'}}>
            <ChartDisplay {...chartProps}/>
        </svg>)



        });
        
    }

    


    if(!sharePage) 
    return (
        <div id={"QuizResultPanel_" + quizId} key={"QuizResultPanel_" + quizId}
            style={{
                width: uiConfig.width + "px",
                height: height + "px",
                backgroundColor: "black",
                overflow: 'auto',
                position : 'relative',
            }}
            className="scrollablePanel">
            <img src={_image} style={{ width: (uiConfig.width + 1) + "px", minWidth: (uiConfig.width + 1) + "px", maxWidth: (uiConfig.width + 1) + "px" }} />
            <div style={{
                position: "absolute",
                top: imageBottom + "px",
                minHeight: (height - imageBottom) + "px",
                backgroundColor: "#1E1D1D",
                width: uiConfig.width + "px",
                maxWidth: uiConfig.width + "px",
                minWidth: uiConfig.width + "px"

            }}>
                <div style={{ width: txtPanelWidth + "px", marginLeft: "auto", marginRight: "auto", marginTop: "50px" }}>
                    <p style={{ fontSize: "45px", fontWeight: 900, textAlign: "center", color: "white", position: "relative", margin : "0px" }}>{title}</p>
                    { (!loadedFromServer) &&<p style={{ fontSize: "18px", fontWeight: 400, textAlign: "center", color: "white", position: "relative",  margin : "0px" }}>Please Wait While We Submit Your Answers.</p>}
                    { (serverError.current) &&<p style={{ fontSize: "18px", lineHeight: "normal", fontWeight: 400, textAlign: "center", color: "white", position: "relative", margin : "0px"}}>Our apologies, there was an error submitting your answers</p>}
                    { (loadedFromServer && quizType == 'quiz' && (!serverError.current)) && 
                    <div style={{ 
                        position : 'relative',
                        
                        display : 'grid',
                        gridTemplateColumns : '75px ' + (txtPanelWidth-75) + 'px',
                        gridTemplateRows : 'auto'}}>
                        {scoreElements}
                        </div>}
                    

                        { (loadedFromServer && quizType == 'survey' && (!serverError.current)) && <div style={{ position : 'relative', display : 'flex', flexDirection : 'column'}}>
                        {surveyElements}
                        </div>}
                    
                </div>
            </div>

            <img src={"/images/fbLogo-small.png"} style={{
                position: "absolute",
                top: logoTop + "px",
                left: "44px",
                width: "81px",
                minWidth: "81px",
                maxWidth: "81px"
            }} />

        </div>
    );
    else if(userAction.current !== null){
        /*const shareTitles = scores.current !== null ? scores.current.shareTitles : ['OOOOPPS'];
        const shareTexts = scores.current !== null ? scores.current.shareTexts : ['OOOOPPS'];
        const shareImages = scores.current !== null ? scores.current.shareImage : ['OOOOPPS'];*/

        const asProps : ActionSharePanelProps = {
            action : userAction.current,
            height : height,
            onQuit : () => {
                setSharePage(false);
            },
            onFinish : () => {
                setSharePage(false);
            }
        }

        return <ActionSharePanel  {...asProps}/>

    }
    else {
        setSharePage(false);
        return <div></div>
    }
}